import { render, staticRenderFns } from "./helpContent.vue?vue&type=template&id=8c6bfb48&"
import script from "./helpContent.vue?vue&type=script&lang=ts&"
export * from "./helpContent.vue?vue&type=script&lang=ts&"
import style0 from "./helpContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports